import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Divider, Input, Select, Space, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  req_add_pim_staff_backfill,
  req_add_pim_staff_overtime,
  req_add_pim_staff_flexible,
  req_add_pim_staff_swap,
} from "../../api";
class DisagreeCaseModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.index = 0;
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    ip: PropTypes.string.isRequired,
  };
  state = {
    lock: false,
    title: "",
    reason: "",
    items: [
      "職工取消申請",
      "已超過申請期限",
      "加班未事先告知",
      "例行事務無須加班",
      "非屬急要加班事由",
      "休息日加班請改用調換方式申請",
      "單月加班累加已超出46小時上限",
      "非因業務需要調換",
      "調換結果造成連續工作逾六天",
    ],
    // items:[
    //   {
    //     label: '通用',
    //     options: [
    //       {
    //         label: '職工取消申請',
    //         value: '職工取消申請',
    //       },
    //       {
    //         label: '已超過申請期限',
    //         value: '已超過申請期限',
    //       },
    //     ],
    //   },
    //   {
    //     label: '加班',
    //     options: [
    //       {
    //         label: '加班未事先告知',
    //         value: '加班未事先告知',
    //       },
    //       {
    //         label: '例行事務無須加班',
    //         value: '例行事務無須加班',
    //       },
    //       {
    //         label: '非屬急要加班事由',
    //         value: '非屬急要加班事由',
    //       },
    //       {
    //         label: '休息日加班請改用調換方式申請',
    //         value: '休息日加班請改用調換方式申請',
    //       },
    //       {
    //         label: '單月加班累加已超出46小時上限',
    //         value: '單月加班累加已超出46小時上限',
    //       },
    //     ],
    //   },
    //   {
    //     label: '調換',
    //     options: [
    //       {
    //         label: '非因業務必須調換',
    //         value: '職工取消申請',
    //       },
    //       {
    //         label: '調換結果造成連續工作逾六天',
    //         value: '調換結果造成連續工作逾六天',
    //       },
    //     ],
    //   },
    // ]
  };

  api_edit_item_overtime_disagree = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_overtime(item, token);
    return result.status;
  };

  api_edit_item_backfill_disagree = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_backfill(item, token);
    return result.status;
  };

  api_edit_item_flexible_disagree = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_flexible(item, token);
    return result.status;
  };

  api_edit_item_swap_disagree = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_swap(item, token);
    return result.status;
  };

  convertDateTime = (string_date, string_time) => {
    const year = string_date.substring(0, 4);
    const month = string_date.substring(4, 6);
    const day = string_date.substring(6, 8);
    const hours = string_time.substring(0, 2);
    const minutes = string_time.substring(2, 4);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  next_applyStatus = (ReviewFinishLevel, ApplyStatus, Status) => {
    switch (ReviewFinishLevel) {
      case "ABC":
        switch (ApplyStatus) {
          case "APPLY": //二級單位主管審查
            return Status === "Y" ? "AY" : "AN";
          case "AY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "ALLAGREE" : "CN";
          default:
            return "NO";
        }
      case "XBC":
        switch (ApplyStatus) {
          case "APPLY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "ALLAGREE" : "CN";
          default:
            return "NO";
        }
      case "ABCDE":
        switch (ApplyStatus) {
          case "APPLY": //二級單位主管審查
            return Status === "Y" ? "AY" : "AN";
          case "AY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "CY" : "CN";
          case "CY": // 人事室承辦主管審查
            return Status === "Y" ? "DY" : "DN";
          case "DY": // 人事室主任審查
            return Status === "Y" ? "ALLAGREE" : "EN";
          default:
            return "NO";
        }
      case "XBCDE":
        switch (ApplyStatus) {
          case "APPLY": //一級單位主管審查
            return Status === "Y" ? "BY" : "BN";
          case "BY": // 人事室承辦人審查
            return Status === "Y" ? "CY" : "CN";
          case "CY": // 人事室承辦主管審查
            return Status === "Y" ? "DY" : "DN";
          case "DY": // 人事室主任審查
            return Status === "Y" ? "ALLAGREE" : "EN";
          default:
            return "NO";
        }
      default:
        return "NO";
    }
  };

  next_statusApplyDescription = (Status) => {
    switch (Status) {
      case "APPLY":
        return "申請中";
      case "AY":
        return "單位二級主管通過";
      case "BY":
        return "單位一級主管通過";
      case "CY":
        return "人事室承辦人通過";
      case "DY":
        return "人事室承辦主管通過";
      case "EY":
        return "人事室主任通過";
      case "ALLAGREE":
        return "申請已通過";
      case "AN":
        return "單位二級主管未通過";
      case "BN":
        return "單位一級主管未通過";
      case "CN":
        return "人事室承辦人未通過";
      case "DN":
        return "人事室承辦主管未通過";
      case "EN":
        return "人事室主任未通過";
      case "ZN":
        return "註銷";
      default:
        return "申請未通過";
    }
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const { userCode } = this.props.user;
    const { reason } = this.state;
    const {
      Id,
      Uid,
      StaffCode,
      ApplyType,
      ReviewFinishLevel,
      ApplyStatus,
      ApplyDate,
    } = item;
    switch (tag) {
      case "DisagreeCase":
        if (reason.length === 0) {
          message.error("請輸入不同意原因");
          return;
        }
        const status = this.next_applyStatus(
          ReviewFinishLevel,
          ApplyStatus,
          "N"
        );
        switch (ApplyType) {
          case "補簽到退申請":
            console.log("補簽到退申請");
            const item_backfill = {
              ApplyType: ApplyType,
              Id: Id,
              Uid: Uid,
              BunchDate: ApplyDate,
              BunchCaseId: Id,
              StaffCode: StaffCode,
              BackFillStatus: status,
              ApplyStatus: status,
              OperatorCode: userCode,
              OperatorDescription:
                reason.length === 0
                  ? this.next_statusApplyDescription(status)
                  : reason,
            };
            console.log(item_backfill);
            this.api_edit_item_backfill_disagree(item_backfill).then(
              (result) => {
                if (result === "success") {
                  message.success("審查完成");
                  this.setState({ lock: true });
                } else {
                  message.error("審查失敗");
                }
              }
            );
            break;
          case "工作日加班申請":
            console.log("工作日加班申請");
            const item_overtime_a = {
              ApplyType: ApplyType,
              Id: Id,
              Uid: Uid,
              OvertimeDate: ApplyDate,
              OvertimeCaseId: Id,
              StaffCode: StaffCode,
              OvertimeStatus: status,
              ApplyStatus: status,
              OperatorCode: userCode,
              OperatorDescription:
                reason.length === 0
                  ? this.next_statusApplyDescription(status)
                  : reason,
            };
            this.api_edit_item_overtime_disagree(item_overtime_a).then(
              (result) => {
                if (result === "success") {
                  message.success("審查完成");
                  this.setState({ lock: true });
                } else {
                  message.error("審查失敗");
                }
              }
            );
            break;
          case "休息日加班申請":
            console.log("休息日加班申請");
            const row_overtime_b = {
              ApplyType: ApplyType,
              Id: Id,
              Uid: Uid,
              OvertimeDate: ApplyDate,
              OvertimeCaseId: Id,
              StaffCode: StaffCode,
              OvertimeStatus: status,
              ApplyStatus: status,
              OperatorCode: userCode,
              OperatorDescription:
                reason.length === 0
                  ? this.next_statusApplyDescription(status)
                  : reason,
            };
            this.api_edit_item_overtime_disagree(row_overtime_b).then(
              (result) => {
                if (result === "success") {
                  message.success("審查完成");
                  this.setState({ lock: true });
                } else {
                  message.error("審查失敗");
                }
              }
            );
            break;
          case "平假日調換申請":
          case "工作日調移申請":
            console.log("調換(移)申請");
            const datePart = ApplyDate.split("<=>")[1];
            const date = datePart.replace(/週.*$/, "").trim();
            const row_swap = {
              ApplyType: ApplyType,
              Id: Id,
              Uid: Uid,
              StaffCode: StaffCode,
              ApplyStatus: status,
              SwapDate: date,
              SwapCaseUid: Uid,
              SwapStatus: status,
              OperatorCode: userCode,
              OperatorDescription:
                reason.length === 0
                  ? this.next_statusApplyDescription(status)
                  : reason,
            };
            this.api_edit_item_swap_disagree(row_swap).then((result) => {
              if (result === "success") {
                message.success("審查完成");
                this.setState({ lock: true });
              } else {
                message.error("審查失敗");
              }
            });
            break;
          case "單日作息調整申請":
            console.log("單日作息調整申請");
            const item_flexible_a = {
              ApplyType: ApplyType,
              Id: Id,
              Uid: Uid,
              StaffCode: StaffCode,
              FlexibleDate: ApplyDate,
              FlexibleCaseId: Id,
              FlexibleStatus: status,
              ApplyStatus: status,
              OperatorCode: userCode,
              OperatorDescription:
                reason.length === 0
                  ? this.next_statusApplyDescription(status)
                  : reason,
            };
            this.api_edit_item_flexible_disagree(item_flexible_a).then(
              (result) => {
                if (result === "success") {
                  message.success("審查完成");
                  this.setState({ lock: true });
                } else {
                  message.error("審查失敗");
                }
              }
            );
            break;
          default:
            break;
        }
        break;
      default:
    }
  };

  switch_title_name(applyType) {
    switch (applyType) {
      case "補簽到退申請":
        return "補簽申請";
      case "工作日加班申請":
        return "加班申請";
      case "休息日加班申請":
        return "加班申請";
      case "平假日調換申請":
        return "平假日調換申請";
      case "工作日調移申請":
        return "工作日調移申請";
      default:
        return "";
    }
  }

  handleNameChange = (event) => {
    this.setState({ reason: event.target.value });
    console.log(this.state.reason);
  };

  handleSelectChange = (value) => {
    this.setState({ reason: value });
  };

  handleAddItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      items: [...prevState.items, this.state.reason || `其他 ${this.index++}`],
      reason: "",
    }));
    setTimeout(() => {
      this.inputRef.current?.focus();
    }, 0);
  };

  ////////
  render() {
    const { data } = this.props;
    //console.log(data);
    return (
      <Card title={"姓名：" + data.StaffName + " 日期：" + data.ApplyDate}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Select
            style={{ height: "40px", width: "100%", marginBottom: "5px" }}
            placeholder={`請選填${data.ApplyType}不同意說明`}
            onChange={this.handleSelectChange}
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider style={{ margin: "8px 0" }} />
                <Space style={{ padding: "0 8px 4px" }}>
                  <Input
                    placeholder="其他"
                    ref={this.inputRef}
                    value={this.state.reason}
                    onChange={this.handleNameChange}
                  />
                  <Button
                    type="text"
                    icon={<PlusOutlined />}
                    onClick={this.handleAddItem}
                  >
                    增加
                  </Button>
                </Space>
              </>
            )}
            options={this.state.items.map((item) => ({
              label: item,
              value: item,
            }))}
          />
          <button
            className="btn btn-warning btn-sm"
            onClick={() => this.handle_btn_event("DisagreeCase", data)}
            disabled={this.state.lock}
          >
            <i className="fas fa-calendar-times"></i> 送出
          </button>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DisagreeCaseModal);
